module.exports = __webpack_public_path__ + "img/a-ziyuan15_1.da274a71.png";